import React, { useState, useEffect } from 'react';
import PageContainer from '../components/layout/PageContainer';
import { motion } from 'framer-motion';
import WhatsAppIcon from '../assets/whatsapp.svg';
import JobModal from '../components/jobs/JobModal';

interface Job {
  id: string;
  title: string;
  company: string;
  location: string;
  salary: string;
  description: string;
  requirements: string[];
  benefits: string[];
  postedAt: string;
  phone: string;
}

const Jobs = () => {
  const [jobs, setJobs] = useState<Job[]>([]);
  const [loading, setLoading] = useState(true);
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const response = await fetch('/jobs.json');
        const data = await response.json();
        setJobs(data);
      } catch (error) {
        console.error('Error loading jobs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  const handleWhatsAppClick = (job: Job) => {
    const message = `Olá! Eu vi a vaga de ${job.title} na empresa ${job.company} no app DizQueTem e gostaria de saber mais informações sobre a vaga.`;
    const whatsappUrl = `https://wa.me/${job.phone}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <PageContainer>
      <div className="space-y-6">
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl p-4">
          <h1 className="text-2xl font-semibold text-white mb-2">
            Vagas de Emprego
          </h1>
          <p className="text-white/80">
            Encontre vagas disponíveis para você
          </p>
        </div>

        {/* Job Listings */}
        <div className="space-y-4">
          {loading ? (
            <div className="text-white/60 text-center py-8">
              Carregando vagas...
            </div>
          ) : (
            jobs.map((job, index) => (
              <motion.div
                key={job.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
                className="bg-white/10 backdrop-blur-lg rounded-xl p-4"
              >
                <div className="flex justify-between items-start mb-4">
                  <div>
                    <h2 className="text-lg font-medium text-white mb-1">
                      {job.title}
                    </h2>
                    <p className="text-white/60 text-sm">
                      {job.company}
                    </p>
                  </div>
                  <p className="text-white/60 text-sm">
                    {new Date(job.postedAt).toLocaleDateString('pt-BR')}
                  </p>
                </div>

                <div className="space-y-3">
                  <div className="space-y-1">
                    <p className="text-white/60 text-sm">
                      {job.location}
                    </p>
                    <p className="text-white/60 text-sm">
                      {job.salary}
                    </p>
                  </div>
                  <div className="flex flex-col gap-2">
                    <button
                      onClick={() => setSelectedJob(job)}
                      className="w-full px-4 py-2 bg-white/10 text-white rounded-lg hover:bg-white/20 transition-colors"
                    >
                      Ver detalhes
                    </button>
                    <button
                      onClick={() => handleWhatsAppClick(job)}
                      className="w-full px-4 py-2 bg-[#25D366] text-white rounded-lg hover:bg-[#25D366]/90 transition-colors flex items-center justify-center gap-2"
                    >
                      <img src={WhatsAppIcon} alt="WhatsApp" className="h-5 w-5" />
                      WhatsApp
                    </button>
                  </div>
                </div>
              </motion.div>
            ))
          )}
        </div>
      </div>

      <JobModal
        job={selectedJob}
        onClose={() => setSelectedJob(null)}
      />
    </PageContainer>
  );
};

export default Jobs; 